module.exports = __webpack_public_path__ + "img/thumbnail-chocaho.dc7de363.jpg";